// DOM-ready helper.
export function ready(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn, { once: true });
  } else {
    fn();
  }
}

// Run after Webflow's own init queue has flushed, so we don't fight its
// interactions. Falls back to plain DOM-ready on non-Webflow pages (e.g. the
// local dev harness), where the Webflow queue would otherwise never flush.
// `fn` runs at most once.
export function afterWebflow(fn) {
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    fn();
  };

  if (window.Webflow && typeof window.Webflow.push === "function") {
    window.Webflow.push(run);
    ready(() => setTimeout(run, 0)); // safety net; guarded so it can't double-run
  } else {
    ready(run);
  }
}
